interface ParsedErrors {
  fieldErrors: Record<string, any>
  globalErrors: any[]
}

export function parseErrors(errors: any[]): ParsedErrors {
  return (errors || []).reduce(
    (memo: ParsedErrors, err: any) => {
      if (err.meta.paramName && err.meta && err.meta.paramName !== 'identifier') {
        memo.fieldErrors[err.meta.paramName] = err
      } else {
        memo.globalErrors.push(err)
      }
      return memo
    },
    {
      fieldErrors: {},
      globalErrors: Array(0)
    }
  )
}
